// Email validation utility - Stricter format
export const validateEmail = (email) => {
    if (!email) return false;

    // Stricter email regex pattern
    // - Requires valid characters before @
    // - Requires valid domain name
    // - Requires valid TLD (at least 2 characters)
    // - Prevents consecutive dots, starts/ends with special chars
    const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

    // Additional checks
    if (!emailRegex.test(email)) return false;

    // Prevent multiple consecutive dots
    if (email.includes('..')) return false;

    // Check email length (max 254 characters as per RFC 5321)
    if (email.length > 254) return false;

    // Split and validate local and domain parts
    const [localPart, domainPart] = email.split('@');

    // Local part (before @) should not exceed 64 characters
    if (localPart.length > 64) return false;

    // Domain part should not be too long
    if (domainPart.length > 253) return false;

    return true;
};

// Password validation utility
export const validatePassword = (password) => {
    return password && password.length >= 6;
};

// Strong password validation (optional - for more strict requirements)
export const validateStrongPassword = (password) => {
    if (!password || password.length < 8) return false;

    // Check for spaces - passwords should not contain any spaces
    if (/\s/.test(password)) return false;

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar;
};

// Name validation utility
export const validateName = (name) => {
    return name && name.trim().length >= 2;
};

// Phone number validation utility
export const validatePhone = (phone) => {
    const phoneRegex = /^[+]?[1-9][\d]{0,15}$/;
    return phoneRegex.test(phone);
};

// Confirm password validation utility
export const validateConfirmPassword = (password, confirmPassword) => {
    return password === confirmPassword;
};

// General validation utility for required fields
export const validateRequired = (value) => {
    return value && value.toString().trim().length > 0;
};

// Length validation utility
export const validateLength = (value, minLength, maxLength = Infinity) => {
    if (!value) return false;
    const length = value.toString().trim().length;
    return length >= minLength && length <= maxLength;
};

// URL validation utility
export const validateURL = (url) => {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

// Age validation utility
export const validateAge = (age) => {
    const numAge = parseInt(age);
    return numAge >= 13 && numAge <= 120;
};
